/**
 * Stats strip — 4 mono-sized numbers in a row. Currently static
 * showcase values from i18n; Phase 4 will wire optional live values
 * from a public `/api/public/stats` endpoint.
 */
import { useTranslation } from 'react-i18next'

const KEYS = ['uptime', 'latency', 'monitoring', 'transparent'] as const

export function StatsStrip() {
  const { t } = useTranslation('landing')
  return (
    <section className="px-6 py-16 md:py-20 border-t border-line bg-surface/40">
      <div className="max-w-6xl mx-auto">
        <div className="text-xs uppercase tracking-[0.2em] text-fire mb-8 text-center">
          {t('stats.section_label')}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-line">
          {KEYS.map((k) => (
            <div key={k} className="bg-ink p-6 text-center">
              <div className="font-mono text-3xl md:text-4xl font-semibold text-fire">
                {t(`stats.items.${k}.value`)}
              </div>
              <div className="mt-2 text-xs text-textDim uppercase tracking-wider">
                {t(`stats.items.${k}.label`)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
